<div *ngIf="isVisible" class="cookie-consent-banner">
  <div class="cookie-content">
    <div class="cookie-text">
      <div class="cookie-icon">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>
      <div class="text-content">
        <h3 class="cookie-title">We Value Your Privacy</h3>
        <p class="cookie-description">
          We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. 
          By clicking "Accept All", you consent to our use of cookies. 
          <a href="javascript:void(0)" (click)="showCookieSettings()" class="cookie-link">Cookie Settings</a>
        </p>
      </div>
    </div>
    <div class="cookie-actions">
      <button class="cookie-btn cookie-btn-reject" (click)="rejectCookies()">
        Reject All
      </button>
      <button class="cookie-btn cookie-btn-accept" (click)="acceptCookies()">
        Accept All
      </button>
    </div>
  </div>
</div>

<div *ngIf="showSettingsModal" class="cookie-settings-modal">
  <div class="cookie-settings-overlay" (click)="closeSettings()"></div>
  <div class="cookie-settings-content">
    <div class="cookie-settings-header">
      <div class="cookie-settings-icon">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </div>
      <div class="cookie-settings-text">
        <h3 class="cookie-settings-title">Cookie Preferences</h3>
        <p class="cookie-settings-description">You can choose which types of cookies to allow.</p>
      </div>
    </div>

    <div class="cookie-options">
      <div class="cookie-option">
        <label class="cookie-option-label">
          <input type="checkbox" [(ngModel)]="cookiePreferences.necessary" disabled class="cookie-checkbox" />
          <span class="cookie-option-text">
            <span class="cookie-option-title">Necessary Cookies</span>
            <span class="cookie-option-description">Essential for the website to function properly. Always active.</span>
          </span>
        </label>
      </div>

      <div class="cookie-option">
        <label class="cookie-option-label">
          <input type="checkbox" [(ngModel)]="cookiePreferences.analytics" class="cookie-checkbox" />
          <span class="cookie-option-text">
            <span class="cookie-option-title">Analytics Cookies</span>
            <span class="cookie-option-description">Help us understand how visitors interact with our website.</span>
          </span>
        </label>
      </div>

      <div class="cookie-option">
        <label class="cookie-option-label">
          <input type="checkbox" [(ngModel)]="cookiePreferences.advertising" class="cookie-checkbox" />
          <span class="cookie-option-text">
            <span class="cookie-option-title">Advertising Cookies</span>
            <span class="cookie-option-description">Used to deliver personalized advertisements and track campaign performance.</span>
          </span>
        </label>
      </div>
    </div>

    <div class="cookie-settings-actions">
      <button class="cookie-settings-btn cookie-settings-btn-cancel" (click)="closeSettings()">
        Cancel
      </button>
      <button class="cookie-settings-btn cookie-settings-btn-save" (click)="saveSettings()">
        Save Preferences
      </button>
    </div>
  </div>
</div>